import React from 'react';

// Tailwind port of the former `SignedOutPageStyled` styled.div. Exposed as a
// function component (instead of a styled.div) so ResetPasswordPage/SignupPage
// can compose it by appending their own classes. The descendant-variant classes
// reproduce the old nested CSS one-for-one (flexVerticalCenter ->
// `flex flex-col justify-around`).
const signedOutPageClasses = [
  'flex flex-col justify-around w-full',
  // .wrapper
  '[&_.wrapper]:text-center [&_.wrapper]:max-w-full [&_.wrapper]:w-[30rem] [&_.wrapper]:m-auto [&_.wrapper]:flex-1 [&_.wrapper]:flex [&_.wrapper]:flex-col [&_.wrapper]:justify-around',
  // .wrapper .inner-wrapper
  '[&_.inner-wrapper]:flex [&_.inner-wrapper]:flex-col [&_.inner-wrapper]:justify-around [&_.inner-wrapper]:w-[30rem] [&_.inner-wrapper]:max-w-full [&_.inner-wrapper]:px-4 [&_.inner-wrapper]:box-border',
  // .inner-wrapper h2
  '[&_.inner-wrapper_h2]:font-bold [&_.inner-wrapper_h2]:mb-2 [&_.inner-wrapper_h2]:text-2xl',
  // .inner-wrapper form
  '[&_.inner-wrapper_form]:flex [&_.inner-wrapper_form]:flex-col [&_.inner-wrapper_form]:justify-around',
  // .inner-wrapper form .inputs
  '[&_.inner-wrapper_form_.inputs]:w-full [&_.inner-wrapper_form_.inputs]:flex [&_.inner-wrapper_form_.inputs]:flex-col [&_.inner-wrapper_form_.inputs]:mb-8',
  // .inner-wrapper form .inputs input
  '[&_.inner-wrapper_form_.inputs_input]:w-full',
  // .inner-wrapper form .form-error
  '[&_.inner-wrapper_form_.form-error]:px-2 [&_.inner-wrapper_form_.form-error]:text-red-2 [&_.inner-wrapper_form_.form-error]:border-l-[3px] [&_.inner-wrapper_form_.form-error]:border-red-2',
  // .inner-wrapper .logo
  '[&_.inner-wrapper_.logo]:h-16 [&_.inner-wrapper_.logo]:mb-4 [&_.inner-wrapper_.logo]:max-w-full mobile:[&_.inner-wrapper_.logo]:w-12 mobile:[&_.inner-wrapper_.logo]:p-4',
  '[&_.inner-wrapper_.logo_img]:w-full',
  // .inner-wrapper .input (mobile only)
  'mobile:[&_.inner-wrapper_.input]:block mobile:[&_.inner-wrapper_.input]:mr-0 mobile:[&_.inner-wrapper_.input]:mb-2 mobile:[&_.inner-wrapper_.input]:w-full',
  // .inner-wrapper button
  '[&_.inner-wrapper_button]:m-auto [&_.inner-wrapper_button]:mt-4 [&_.inner-wrapper_button]:w-full',
  '[&_.inner-wrapper_button_.button-label]:text-center [&_.inner-wrapper_button_.button-label]:w-full',
  // .inner-wrapper a
  '[&_.inner-wrapper_a]:font-bold',
  // .wrapper .login-error
  '[&_.wrapper_.login-error]:text-red-2',
  // .forgot-password
  '[&_.forgot-password]:text-primary [&_.forgot-password]:mb-4',
  // .buttons
  '[&_.buttons]:flex [&_.buttons]:flex-col [&_.buttons]:gap-3',
].join(' ');

interface SignedOutPageProps {
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const SignedOutPageStyled = ({ className, children, ...rest }: SignedOutPageProps) => (
  <div className={`${signedOutPageClasses}${className ? ` ${className}` : ''}`} {...rest}>
    {children}
  </div>
);
